import logo from "@/assets/tecopos-logo.png";

export function Logo({ className = "", showWordmark = true }: { className?: string; showWordmark?: boolean }) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <img src={logo} alt="TecoPOS" width={28} height={28} className="size-7 lg:size-8 object-contain" />
      {showWordmark && (
        <span className="text-xl lg:text-2xl font-bold tracking-tight">
          Teco<span className="text-primary">POS</span>
        </span>
      )}
    </span>
  );
}
